<template>
  <!-- 汇率变化趋势 -->
  <div class="table_container">
    <table>
      <tbody align="center">
        <tr>
          <th width="100px">
            <span style="color: #F56C6C">*</span>货币兑换关系
          </th>
          <th width="50px">周期</th>
          <th colspan="4">{{ `${Number(queryParams.years) - 3}年` }}</th>
          <th colspan="4">{{ `${Number(queryParams.years) - 2}年` }}</th>
          <th colspan="4">{{ `${Number(queryParams.years) - 1}年` }}</th>
        </tr>
        <tr>
          <td rowspan="5" @click="handleColumn('currencyExchangeRelationship')">
            <el-input
              v-if="editField === 'currencyExchangeRelationship'"
              ref="focusRef"
              v-model="form.currencyExchangeRelationship"
              size="mini"
              placeholder="请输入"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input>
            <span v-else>
              {{ form.currencyExchangeRelationship }}
            </span>
          </td>
          <th>季度</th>
          <th v-for="(item, index) in Qlist" :key="index">
            {{ item.quarter }}
          </th>
        </tr>
        <tr>
          <th>汇率</th>
          <th v-for="(item, index) in Qlist" :key="index">
            {{ beforeThreeRate[item.exchangeRateField] }}
          </th>
        </tr>
        <tr>
          <th></th>
          <th colspan="12">{{ `${queryParams.years}年` }}</th>
        </tr>
        <tr>
          <th>月度</th>
          <th v-for="(item, index) in monthList" :key="index">
            {{ item.month }}
          </th>
        </tr>
        <tr v-if="Number(queryParams.years) >= 2025">
          <th>汇率</th>
          <td
            v-for="(item, index) in monthList"
            :key="index"
            @click="handleColumn(item.exchangeRateField)"
          >
            <el-input-number
              v-if="editField === item.exchangeRateField"
              ref="focusRef"
              class="number_input"
              :controls="false"
              :precision="2"
              v-model="form[item.exchangeRateField]"
              size="mini"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ form[item.exchangeRateField] }}
            </span>
          </td>
        </tr>
        <tr v-else>
          <th>汇率</th>
          <th v-for="(item, index) in monthList" :key="index">
            {{ form[item.exchangeRateField] }}
          </th>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { addOrUpdateExchangeRateChangeTrendApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      beforeThreeRate: {},
      form: this.getForm(),
      rules: {
        currencyExchangeRelationship: [
          { required: true, message: "货币兑换关系不能为空", trigger: "blur" }
        ]
      },
      editField: "", // 编辑单元格
      Qlist: [
        {
          quarter: "Q1",
          exchangeRateField: "firstQ1Rate"
        },
        {
          quarter: "Q2",
          exchangeRateField: "firstQ2Rate"
        },
        {
          quarter: "Q3",
          exchangeRateField: "firstQ3Rate"
        },
        {
          quarter: "Q4",
          exchangeRateField: "firstQ4Rate"
        },
        {
          quarter: "Q1",
          exchangeRateField: "secondQ1Rate"
        },
        {
          quarter: "Q2",
          exchangeRateField: "secondQ2Rate"
        },
        {
          quarter: "Q3",
          exchangeRateField: "secondQ3Rate"
        },
        {
          quarter: "Q4",
          exchangeRateField: "secondQ4Rate"
        },
        {
          quarter: "Q1",
          exchangeRateField: "thirdQ1Rate"
        },
        {
          quarter: "Q2",
          exchangeRateField: "thirdQ2Rate"
        },
        {
          quarter: "Q3",
          exchangeRateField: "thirdQ3Rate"
        },
        {
          quarter: "Q4",
          exchangeRateField: "thirdQ4Rate"
        }
      ], // 季度
      monthList: [
        {
          month: "1月",
          exchangeRateField: "oneRate"
        },
        {
          month: "2月",
          exchangeRateField: "twoRate"
        },
        {
          month: "3月",
          exchangeRateField: "threeRate"
        },
        {
          month: "4月",
          exchangeRateField: "fourRate"
        },
        {
          month: "5月",
          exchangeRateField: "fiveRate"
        },
        {
          month: "6月",
          exchangeRateField: "sixRate"
        },
        {
          month: "7月",
          exchangeRateField: "sevenRate"
        },
        {
          month: "8月",
          exchangeRateField: "eightRate"
        },
        {
          month: "9月",
          exchangeRateField: "nineRate"
        },
        {
          month: "10月",
          exchangeRateField: "tenRate"
        },
        {
          month: "11月",
          exchangeRateField: "elevenRate"
        },
        {
          month: "12月",
          exchangeRateField: "twelveRate"
        }
      ] // 月度
    };
  },
  methods: {
    init(data, queryParams = {}) {
      this.queryParams = { ...queryParams };
      this.beforeThreeRate = data.beforeThreeRate || {};
      this.form = this.getForm(data.searchYearRate || {});
    },
    // 获取表单数据
    getForm(data = {}) {
      return {
        id: data.id || "",
        currencyExchangeRelationship:
          data.currencyExchangeRelationship ||
          this.beforeThreeRate?.currencyExchangeRelationship ||
          "",
        oneRate: data.oneRate ?? undefined,
        twoRate: data.twoRate ?? undefined,
        threeRate: data.threeRate ?? undefined,
        fourRate: data.fourRate ?? undefined,
        fiveRate: data.fiveRate ?? undefined,
        sixRate: data.sixRate ?? undefined,
        sevenRate: data.sevenRate ?? undefined,
        eightRate: data.eightRate ?? undefined,
        nineRate: data.nineRate ?? undefined,
        tenRate: data.tenRate ?? undefined,
        elevenRate: data.elevenRate ?? undefined,
        twelveRate: data.twelveRate ?? undefined
      };
    },
    // 点击单元格编辑
    handleColumn(field) {
      this.editField = field;
      this.$nextTick(() => {
        if (Array.isArray(this.$refs.focusRef)) {
          this.$refs.focusRef[0]?.focus();
        } else {
          this.$refs.focusRef?.focus();
        }
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
    },
    // 保存
    async handleSave(callBack) {
      for (const key in this.rules) {
        if (!this.form[key]) {
          this.$DonMessage.error(this.rules[key][0].message);
          return;
        }
      }
      try {
        const submitData = JSON.parse(
          JSON.stringify({ ...this.queryParams, ...this.form })
        );
        const res = await addOrUpdateExchangeRateChangeTrendApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.form.id = res.data.id;
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 0 18px 0 50px;

  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
  }
  th,
  td {
    border: 1px solid #dcdfe6;
    padding: 4px 12px;
    height: 40px;
    font-size: 14px;
    word-break: break-all;
  }
  th {
    background-color: #f2f2f2;
  }
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
}
</style>
